import styled from 'styled-components';
import * as S from '../styled';

export const InnerContainer = styled(S.InnerContainer)`
    align-items: flex-start;
`;

export const SectionTitle = styled(S.SectionTitle)`
    text-align: left;
    max-width: 780px;
    margin-bottom: 40px;
    padding: 0 8px;
`;

export const LinkWrap = styled.div`
    display: flex;
    width: 100%;
    max-width: 780px;
    margin-top: 15px;
    padding: 0 8px;
`;
